export default "__VITE_ASSET__DYpe6ULZ__"